import React, { useEffect, useState } from "react"
import "./advantage.sass"
import IconFork from "../../images/icon-fork@2x.png"
import IconCar from "../../images/icon-car@2x.png"
import IconMap from "../../images/icon-map@2x.png"
import VisibilitySensor from "react-visibility-sensor"
import { $c, defaultIntl } from "../../utils"

export default ({ intl = defaultIntl }) => {
  const [visible, setVisible] = useState(false)
  return (
    <VisibilitySensor onChange={v => setVisible(v)}>
      <div className="advantage">
        <div className="container">
          <h2>{intl.formatMessage({ id: "index.advantages.title" })}</h2>
          <div className={$c("text-content")(visible, "fadeInup")}>
            <p>{intl.formatMessage({ id: "index.advantages.desc" })}</p>
          </div>
          <div className="columns is-multiline is-centered">
            <div className="column is-one-third">
              <div className="image-box">
                <figure className="image is-19by18">
                  <img src={IconFork} alt="" />
                </figure>
              </div>
              <h3>{intl.formatMessage({ id: "index.advantages.a.title" })}</h3>
              <p>{intl.formatMessage({ id: "index.advantages.a.desc" })}</p>
            </div>
            <div className="column is-one-third">
              <div className="image-box">
                <figure className="image is-19by18">
                  <img src={IconCar} alt="" />
                </figure>
              </div>
              <h3>{intl.formatMessage({ id: "index.advantages.b.title" })}</h3>
              <p>{intl.formatMessage({ id: "index.advantages.b.desc" })}</p>
            </div>
            <div className="column is-one-third">
              <div className="image-box">
                <figure className="image is-19by18">
                  <img src={IconMap} alt="" />
                </figure>
              </div>
              <h3>{intl.formatMessage({ id: "index.advantages.c.title" })}</h3>
              <p>{intl.formatMessage({ id: "index.advantages.c.desc" })}</p>
            </div>
          </div>
        </div>
      </div>
    </VisibilitySensor>
  )
}
